package com.example.mystybag.appCore.model.pages

import com.example.mystybag.sharedmodels.project.database.UserReservationModel
import com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel
import com.example.mystybag.sharedmodels.project.responseModels.merchant.GetBagDetailsResponseModel

data class ReservationDetailsBottomSheetUIState(
    val reservation: UserReservationModel,
    /** Торба от текущия каталог на Начало (ако я има там) — за линк „Виж торбата“ и навигация без допълнително API. */
    val matchedCatalogBag: HomeTopPickUiModel? = null,
    val isLoading: Boolean = false,
    val isError: Boolean = false,
    val errorMessage: String = "",
    val showRatingForm: Boolean = false,
    // These fields represent ratings for the 4 rating categories
    // The meaning depends on businessCategoryId (see ReviewCategoryConfigs)
    val ratingCategory1: Int = 0, // Rating for first category (varies by business category)
    val ratingCategory2: Int = 0, // Rating for second category (varies by business category)
    val ratingCategory3: Int = 0, // Rating for third category (varies by business category)
    val ratingCategory4: Int = 0, // Rating for fourth category (varies by business category)
    val isSubmittingReview: Boolean = false,
    val isReviewSubmitted: Boolean = false,
    val reviewCategories: List<ReviewRatingCategory> = emptyList(), // Dynamic categories based on business category
    val fullScreenMenuPhotoUrl: String? = null, // When set, show menu photo full screen with close button
    // Loaded from merchant location (getMerchantLocations + find by merchantLocationId)
    val loadedPickupAddress: String? = null,
    val loadedLocationLatitude: Double = 0.0,
    val loadedLocationLongitude: Double = 0.0,
    // Loaded from bag details (getBagDetails) – pickup time window
    val loadedCollectWindowLabel: String? = null,
    // Loaded from bag details – total amount (priceWithDiscount * bagsCount + currency)
    val loadedAmountFormatted: String? = null,
    /** Full bag details response (for navigation to bag screen). */
    val loadedBagDetails: GetBagDetailsResponseModel? = null
)

